export default "__VITE_PUBLIC_ASSET__2fa315e1__"